export default "__VITE_ASSET__4cc10737__"